import React, { useState } from 'react';
import { FaHeartbeat, FaSpinner, FaExpand, FaCompress } from 'react-icons/fa';

const URL = 'https://copy-of-debt-detox-360-881884204486.us-west1.run.app/';

const DebtDetox360 = () => {
  const [loading, setLoading] = useState(true);
  const [fs, setFs] = useState(false);

  return (
    <div className={`${fs ? 'fixed inset-0 z-50 bg-[#0A1929]' : 'space-y-4'}`}>
      <div className={`bg-gradient-to-r from-[#1A2942] to-[#1E3A5F] ${fs ? 'p-4' : 'rounded-xl p-6'} border-b border-[#2D5A8F]`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#FFD700] to-[#FFA500] flex items-center justify-center">
              <FaHeartbeat size={20} className="text-[#0A1929]" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-white">Debt Detox 360</h2>
              <p className="text-gray-400">Debt Management & Recovery</p>
            </div>
          </div>
          <button onClick={() => setFs(!fs)} className="p-2 bg-[#2D5A8F] text-white rounded-lg hover:bg-[#3D6A9F] transition-all" data-testid="debt-detox-fullscreen-btn">
            {fs ? <FaCompress size={18} /> : <FaExpand size={18} />}
          </button>
        </div>
      </div>
      <div className={`relative ${fs ? 'h-[calc(100vh-88px)]' : 'h-[calc(100vh-220px)] min-h-[600px]'} bg-[#0F172A] ${fs ? '' : 'rounded-xl'} border border-[#2D5A8F] overflow-hidden`}>
        {loading && <div className="absolute inset-0 flex items-center justify-center bg-[#0A1929] z-10"><div className="text-center"><FaSpinner className="animate-spin text-[#FFD700] text-4xl mx-auto mb-4" /><p className="text-gray-400">Loading Debt Detox 360...</p></div></div>}
        <iframe src={URL} title="Debt Detox 360" className="w-full h-full border-0" onLoad={() => setLoading(false)} allow="fullscreen" data-testid="debt-detox-iframe" />
      </div>
      {!fs && <div className="text-center text-gray-500 text-sm"><p>Debt Detox 360 powered by MDRT School</p></div>}
    </div>
  );
};

export default DebtDetox360;
